// extracted by mini-css-extract-plugin
module.exports = {"courses":"courses_courses__50Lxb","card":"courses_card__I3R70","courseImage":"courses_courseImage__35uFY","title":"courses_title__11YFo","description":"courses_description__24hB5"};